import React from "react";
import { Col, Container as GridContainer, Row } from "react-native-flex-grid";
import { Box, FormattedDate, HStack, Link, Text, Typography } from "components/ui";
import { Ellipsis, Tractor, Bike } from "lucide-react-native";
import { useToken } from "@gluestack-style/react";
import { useIsMobile } from "utils/hooks/useIsMobile";
import { TechnicianTrip } from "store/abcoApi";
type Props = {
	dataList: TechnicianTrip[] | null | undefined;
};

const ServiceOrderTechnicianTripTable = ({ dataList }: Props) => {
	const isMobile = useIsMobile();
	const resolvedPrimarylight = useToken("colors", "primarylight");
	return (
		<GridContainer
			noPadding
			style={{
				marginLeft: 0,
				maxWidth: "100%",
				marginBottom: 30,
			}}
		>
			{dataList && dataList.length === 0 && (
				<>
					<Box style={{ marginLeft: 0, marginRight: 0, paddingHorizontal: isMobile ? 0 : 16, paddingVertical: 12, borderRadius: 8, borderWidth: 1, marginBottom: 0, borderColor: "#E1E9F0" }}>
						<Text style={{ textAlign: "center" }}>No technician trip record found</Text>
					</Box>
				</>
			)}

			{!isMobile && dataList && dataList.length > 0 && (
				<Row style={{ marginLeft: 0, marginRight: 0, marginBottom: 14, width: "100%", paddingHorizontal: 16 }}>
					<Col>
						<Text color="$neutral600">Type</Text>
					</Col>
					<Col>
						<Text color="$neutral600">Title</Text>
					</Col>
					<Col>
						<Text color="$neutral600">Details</Text>
					</Col>
					<Col>
						<Text color="$neutral600">Technician</Text>
					</Col>
					<Col>
						<Text color="$neutral600">StartDate</Text>
					</Col>
					<Col>
						<Text color="$neutral600">EndDate</Text>
					</Col>
					<Col>
						<Text color="$neutral600">Status</Text>
					</Col>
				</Row>
			)}

			{dataList &&
				dataList.map((technicianTrip: any) => {
					return (
						<Box position="relative" key={technicianTrip.id}>
							{(() => {
								var styleData = { marginLeft: 0, marginRight: 0, paddingHorizontal: isMobile ? 0 : 16, paddingVertical: 18, borderRadius: 8, borderWidth: 1, marginBottom: 14, borderColor: "#E1E9F0", background: "white" };

								if (isMobile) {
									return (
										<Row style={styleData} key={technicianTrip.id}>
											<Col>
												<Row style={{ paddingBottom: 8 }}>
													<Col style={{ flexDirection: "row", justifyContent: "space-between", alignItems: "center" }}>
														<HStack gap={8} alignItems="center" flex={1}>
															<Tractor color={resolvedPrimarylight} size={20} />
															<Text>{technicianTrip.title}</Text>
														</HStack>
														<HStack gap={8} alignItems="center">
															<FormattedDate sx={{ color: "$neutral600", fontSize: 12 }} variant="DD/MMM" date={technicianTrip.startDate} />
														</HStack>
													</Col>
												</Row>
												<Row style={{ paddingBottom: 4 }}>
													<Col>
														<HStack gap={4} alignItems="center">
															<Text color="$neutral600" fontSize={13}>
																{technicianTrip.details}
															</Text>
														</HStack>
													</Col>
												</Row>
												<Row style={{ paddingBottom: 4 }}>
													<Col>
														<HStack gap={8} alignItems="center">
															<Bike color={resolvedPrimarylight} size={16} />
															<Text color="$neutral600" fontSize={13}>
																{technicianTrip.type}
															</Text>
														</HStack>
													</Col>
												</Row>
												<Row style={{ paddingBottom: 4 }}>
													<Col>
														<HStack gap={4} alignItems="center">
															<Text color="$neutral400" fontSize={13}>
																{technicianTrip.technician}
															</Text>
														</HStack>
													</Col>
												</Row>
												<Row>
													<Col>
														<HStack gap={8} alignItems="center">
															<FormattedDate sx={{ color: "$neutral600", fontSize: 12 }} variant="DD/MMM" date={technicianTrip.endDate} />
															<Box bg="$primary100" px={2} py={1} borderRadius={4}>
																<Text fontWeight="bold" fontSize={12} color="$primary600">
																	{technicianTrip.status}
																</Text>
															</Box>
														</HStack>
													</Col>
												</Row>
											</Col>
										</Row>
									);
								}
								return (
									<Row style={styleData} key={technicianTrip.id}>
										<Col style={{ justifyContent: "center" }}>
											<HStack gap={8} alignItems="center">
												<Bike color={resolvedPrimarylight} size={20} />
												<Text color="$neutral600">{technicianTrip.type}</Text>
											</HStack>
										</Col>
										<Col style={{ justifyContent: "center" }}>
											<HStack gap={8}>
												<Text>{technicianTrip.title}</Text>
											</HStack>
										</Col>
										<Col style={{ justifyContent: "center" }}>
											<HStack gap={8}>
												<Text color="$neutral600">{technicianTrip.details}</Text>
											</HStack>
										</Col>
										<Col style={{ justifyContent: "center" }}>
											<HStack gap={8}>
												<Text color="$neutral600">{technicianTrip.technician}</Text>
											</HStack>
										</Col>
										<Col style={{ justifyContent: "center" }}>
											<HStack gap={8}>
												<FormattedDate sx={{ color: "$neutral600" }} variant="DD/MM/YYYY" date={technicianTrip.startDate} />
											</HStack>
										</Col>
										<Col style={{ justifyContent: "center" }}>
											<HStack gap={8}>
												<FormattedDate sx={{ color: "$neutral600" }} variant="DD/MM/YYYY" date={technicianTrip.endDate} />
											</HStack>
										</Col>
										<Col style={{ justifyContent: "center" }}>
											<HStack gap={8}>
												<Text>{technicianTrip.status}</Text>
											</HStack>
										</Col>
									</Row>
								);
							})()}
						</Box>
					);
				})}
		</GridContainer>
	);
};

export default ServiceOrderTechnicianTripTable;
